import React from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonModal, IonFooter, IonHeader } from '@ionic/react'
import { storeMobx, deliveryMobx, buyTogetherMobx, memberMobx } from '@mobxStore'
import { Icon, AddressItem } from '@cps'
import deliveryController from '@ctrls/deliveryController'
import { confirmLayer, toast } from '@utils'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { restaurantConfig } from 'restaurant'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (data?: any) => void;
  type?: string; // 来源 mall 商城
  eatType?: TEEatType;
}

/** 切换门店弹窗提示 */
export const hasStoreModal = (store: IViewStore) => {
  confirmLayer({
    title: i18n.t('common.attention'),
    children: (

      <>
        <div className='near-tip'>{i18n.t('newCart.matchNearStore')}</div>
        <div className='near-store'>
          <Icon name='dinein3' />{store?.storeName}
        </div>
      </>
    ),
    className: 'near-store-confirm-modal',
    isLight: true,
    canClose: true,
  }).then(() => {
  }, () => { })
}

const SelectAddressModal: React.FC<IProps> = (props) => {
  const { reject, resolve, type = '', eatType } = props
  const isBuyTogether = Config.buyTogetherId || type === 'buyTogether'
  const viewAddressesList = isBuyTogether ? buyTogetherMobx.viewAddressList : deliveryMobx.viewAddresses
  const isCheckedAddress = isBuyTogether ? buyTogetherMobx.addressInfo : deliveryMobx.address

  const checkAddress = (info) => {
    const address = deliveryMobx.verifyAddresses([info])[0] || deliveryMobx.viewAddresses?.find(addr => addr.memberAddressId === info?.memberAddressId)
    /** 开启切换地址，自动切换最近门店功能 */
    const openAutoChangeStoreFormAddress = !!boJudge.checkGrayKey('openAutoChangeStoreFormAddress')
    if (!openAutoChangeStoreFormAddress && (address?.inArea && address?.inCityId)) {
      deliveryMobx.setAddress(address, type)
      resolve(address)
    } else {
      if (address.memberAddressId === deliveryMobx.address?.memberAddressId) {
        deliveryMobx.resetAddress()
      }
      const store = deliveryMobx.getNearByStore({
        address: address,
        notStoreId: !openAutoChangeStoreFormAddress ? storeMobx.info.storeId : 0
      }) as IViewStore
      if (store) {
        deliveryMobx.setAddress(address, type)
        if (storeMobx.info.storeId !== store.storeId) {
          hasStoreModal(store)
        }
        storeMobx.initInfo(store as IViewStore)
        resolve(address)
      } else {
        toast({
          message: `${i18n.t('location.noStoreInAddress')},<br/>${i18n.t('location.noStoreInAddress2')}`,
          time: 2000,
          position: 'middle',
          cssClass: 'toastW50'
        })
      }
    }
  }

  const handleEdit = (address?: any) => {
    const _info = address ? cloneDeep(address) : null
    if (_info) {
      delete _info.inArea
      delete _info.inCityId
      delete _info.lbsLat
      delete _info.lbsLng
    }
    deliveryController.editAddressModal({
      address,
      type,
      eatType,
      callback: (store) => {
        if (type === 'mall' || (type === 'buyTogether' && !Config.buyTogetherId)) {
          !!address && setTimeout(() => handleSelect(address), 300)
          resolve(address)
          return
        } else if (!type) {
          !!store && storeMobx.initInfo(store as IViewStore)
          resolve(address)
        }
      }
    })
  }

  const handleSelect = (info: any) => {
    let address: any = null
    if (isBuyTogether) {
      resolve(info)
    } else if (type === 'mall') {
      address = deliveryMobx.viewAddressesAll.find(addr => addr?.memberAddressId === info.memberAddressId)
      deliveryMobx.setAddress(address, type)
      resolve(address)
    } else {
      address = deliveryMobx.viewAddresses.find(addr => addr?.memberAddressId === info.memberAddressId)
      checkAddress(address)
    }
  }
  const deleteAddress = (info: any) => {
    memberMobx.deleteMemberAddress(info.memberAddressId)
  }

  const handleClose = () => {
    reject()
  }

  return (
    <IonModal
      isOpen
      swipeToClose
      cssClass='select-address-modal'
      onDidDismiss={handleClose}
    >
      <IonHeader>
        <div className='select-address-header'>
          <span>{i18n.t('newCart.selectAddress')}</span>
          <Icon name='close' data-cypid='selectAddressModalClose' onClick={handleClose} />
        </div>
      </IonHeader>
      {
        type === 'mall' ? (
          <IonContent>
            <div className='address-group'>
              {
                deliveryMobx.viewAddressesAll.map((address: any) => (
                  <div className='address-item check' key={address.memberAddressId} data-cypid={`selectAddressItem_${address?.memberAddressId}`} onClick={() => handleSelect(address)}>
                    <div className='address-check'>
                      <Icon name={address?.memberAddressId === deliveryMobx.address?.memberAddressId ? 'checked' : 'circle'} />
                    </div>
                    <AddressItem info={address} onSelect={handleSelect} onEdit={(address) => handleEdit(address)} onDelete={() => deleteAddress(address)} />
                  </div>
                ))
              }
            </div>
          </IonContent>
        ) : (
          <IonContent>
            <div className='address-group'>
              {!!restaurantConfig.lbsAddress && (
                <div className='address-title'>
                  <div className='address-lbs-wrapper'>
                    <Icon name='mubiao' />
                    <span>{i18n.t('location.useLbsAddress')}: {restaurantConfig.lbsAddress}</span>
                  </div>
                </div>
              )}
              {
                viewAddressesList.filter(addr => addr.inArea && addr.inCityId).map((address: any) => (
                  <div className='address-item check' key={address.memberAddressId} data-cypid={`selectAddressItem_${address?.memberAddressId}`} onClick={() => handleSelect(address)}>
                    <div className='address-check'>
                      <Icon name={address?.memberAddressId === isCheckedAddress?.memberAddressId ? 'checked' : 'circle'} />
                    </div>
                    <AddressItem info={address} onSelect={handleSelect} onEdit={(address) => handleEdit(address)} onDelete={() => deleteAddress(address)} />
                  </div>
                ))
              }
            </div>
            {
              viewAddressesList.filter(addr => !addr.inArea || !addr.inCityId)?.length ? (
                <div className='address-group'>
                  {isBuyTogether && <div className='address-title'>{i18n.t(bo === 'cn' ? 'newCart.outStoreAddress' : 'newCart.outStoreAddressOrNoTax')}</div>}
                  {
                    viewAddressesList.filter(addr => !addr.inArea || !addr.inCityId)?.map((address: any) => (
                      <div className='address-item check' key={address.memberAddressId} onClick={() => handleSelect(address)}>
                        <div className='address-check'>
                          <Icon name={address?.memberAddressId === isCheckedAddress?.memberAddressId ? 'checked' : 'circle'} />
                        </div>
                        <AddressItem info={address} onSelect={handleSelect} onEdit={(address) => handleEdit(address)} onDelete={() => deleteAddress(address)} />
                      </div>
                    ))
                  }
                </div>
              ) : null
            }
          </IonContent>
        )
      }
      <IonFooter>
        <div className='select-address-footer' onClick={() => handleEdit()}>
          <Icon name='add2' />
          {i18n.t('newCart.addAddress')}
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(SelectAddressModal)
